import React from 'react'
// @ts-ignore no types
import { Button, constants, useApplicationContext } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import { PATH_CONFIG, getPurchasePaths } from 'common/utils/listingPaths'
import type { Listing } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import analytics from 'common/services/analytics'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)

// Short tab copy + active color per path (selector-specific presentation).
const TAB = {
  privateSeller: {
    label: 'Make an Offer',
    activeColor: constants.ColorNames.Purple,
  },
  foreclosure: {
    label: 'Bid at Foreclosure',
    activeColor: constants.ColorNames.Action,
  },
}

export const ListingSelectorComponent = () => {
  const { featureFlags } = useApplicationContext()
  const { listing, activeListings, listingActions } = useListingContext()

  const paths = getPurchasePaths(activeListings)
  if (paths.length < 2) return null

  const unifiedPdpEnabled = featureFlags?.['fe.resi.enable-unified-pdp']
  const activeType = paths.find(
    p => p.listing.listing_id === listing?.listing_id
  )?.type

  // When unified PDP is off, only surface the selector on the foreclosure
  // listing (legacy behavior).
  if (!unifiedPdpEnabled && activeType !== 'foreclosure') return null

  const switchToListing = (target: Listing, type: keyof typeof TAB) => {
    if (target.listing_id === listing?.listing_id) return
    analytics.dualTrack.pathSelected({
      path: PATH_CONFIG[type].analyticsPath,
      source: 'toggle',
    })
    listingActions?.setCurrentListingId(target.listing_id)
  }

  return (
    <div className={cx('toggle-container')} data-elm-id='listing-selector'>
      {paths.map(path => {
        const active = path.listing.listing_id === listing?.listing_id
        return (
          <Button
            key={path.type}
            tag='button'
            role='tertiary'
            color={
              active ? TAB[path.type].activeColor : constants.ColorNames.Gray
            }
            isStretch
            className={cx('toggle-tab', { 'toggle-tab-active': active })}
            onClick={() => switchToListing(path.listing, path.type)}
            elmId={`listing-selector_${PATH_CONFIG[path.type].elmId}`}
          >
            {TAB[path.type].label}
          </Button>
        )
      })}
    </div>
  )
}

export default ListingSelectorComponent
